import { inputProps } from 'mixins/FormFieldMixin'

export default {
    props: {
        formPrefills: { type: Object, default: null },
    },

    computed: {
        inputProps() {
            return {
                ...inputProps(this),
                prefill: this.$get(this.formPrefills, this.valuePath),
            }
        },
    },
}
